export enum EImageType {
  /** Фото поэтажки **/
  FloorPlan = 'floorPlan',
  /** Фото планировки **/
  Layout = 'layout',
  /** Обычная картинка **/
  Normal = 'normal',
}

export interface IImage {
  url: string;
  thumbnailUrl: string;
}

export interface ITypedImage extends IImage {
  type: EImageType;
}
